import './styles/@theme';

export const NotFoundComponent = () => {
    return (
        <div className="container-404">
            <span className="title">That shouldn&#39;t have happened.</span>
            <span className="description">The page you requested could not be found.</span>
            <a href={'/'} className="primary-button">
                Go to home
            </a>
        </div>
    );
};
